import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import Err from "../../../../../../routes/error";
import { mapActions, mapGetters } from "vuex";
import { ADD_NOTE } from "@Broker/@Modules/clients/board/store/board-actions";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { timeBombTooltip } from "../../../../../../custom/utils";
import HTMLTextEvaluationMixin from "@Shared/utils/application-mixins/html-text-evaluation-mixin";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { showToast } from "@Shared/utils/constants";
import { CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_TAGS } from "../../../store/board-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NoteTab",
  mixins: [HTMLTextEvaluationMixin],
  props: {
    tabData: {
      type: Object,
      default: () => ({})
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    currentTab: {
      type: String,
      required: true
    },
    external: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return _objectSpread({
      createWithActivity: false,
      editor: null,
      note: ""
    }, this.tabData);
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [CLIENT_PROFILE_CUSTOM_FIELDS_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS])), {}, {
    canSave() {
      return this.htmlToTextContent(this.note) !== "";
    },
    customFieldsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_TAGS(this.clientProfileId);
    },
    customFieldsHintsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS(this.clientProfileId);
    }
  }),
  watch: {
    customFieldsTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    customFieldsHintsTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [ADD_NOTE])), {}, {
    init() {
      const target = $(this.$refs.noteField);
      this.editor = new RichTextEditor(target, {
        placeholder: this.$t("client-profile.messages.startTypingToLeaveNote"),
        airMode: true,
        height: "6vw",
        substitutionHints: true,
        showMergeTags: true,
        loadPreferences: false,
        visible: this.currentTab === "note",
        mergeTags: defaults => {
          return [...defaults, ...this.customFieldsTags];
        },
        hints: defaults => {
          return [...defaults, ...this.customFieldsHintsTags];
        },
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
      this.createWithActivity = false;
      $(".note-codable").attr("id", "start-typing-id");
    },
    handleSubmit() {
      this.addNote();
    },
    async addNote() {
      const submitButton = $(this.$refs.submitNote);
      try {
        submitButton.animateButton().animate("start");
        const noteId = await this.ADD_NOTE({
          id: this.clientProfileId,
          note: this.editor.getHTML()
        });
        showToast("success", "notedAdded");
        Amplitude.updateCount("CLIENT_PROFILE_NOTES_CREATED");
        await submitButton.animateButton().animate("finish");
        this.$emit("submit");
        $(this.$refs.noteField).val("");
        this.editor.setHTML("");
        this.note = "";
        if (this.createWithActivity) {
          showBModal("activity-convert-modal", {
            id: noteId,
            activityType: "note"
          }, this);
          this.$nextTick(() => {
            this.createWithActivity = false;
          });
        }
        submitButton.removeClass("form-finish");
      } catch (e) {
        Err.handle(e);
        await submitButton.animateButton().animate("finish", "failed");
      }
    },
    handleAddNote(createWithActivity) {
      this.createWithActivity = createWithActivity;
      this.handleSubmit();
      if (!createWithActivity) {
        this.showAddTooltip();
      }
    },
    async showAddTooltip() {
      const target = $(this.$refs.addTipTooltip);
      timeBombTooltip(target, {
        placement: "left",
        trigger: "manual"
      });
    },
    handleEditorChange(_, content) {
      this.note = content;
    }
  })
});